import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getFaqs = () =>
  axiosInstance.get(`${LANDING_API_URL}/faq`, {
    headers: authHeaders(),
  });

export const createFaqRequest = (faqData) =>
  axiosInstance.post(`${LANDING_API_URL}/faq`, faqData, {
    headers: authHeaders(),
  });

export const updateFaqRequest = (id, faqData) =>
  axiosInstance.put(`${LANDING_API_URL}/faq/${id}`, faqData, {
    headers: authHeaders(),
  });

export const removeFaq = (faqId) =>
  axiosInstance.delete(`${LANDING_API_URL}/faq/${faqId}`, {
    headers: authHeaders(),
  });
